module.exports = __webpack_public_path__ + "static/media/RH45PN.826fd880.jpg";